import { render, staticRenderFns } from "./DeptPicker.vue?vue&type=template&id=51b7132c&scoped=true"
import script from "./DeptPicker.vue?vue&type=script&lang=js"
export * from "./DeptPicker.vue?vue&type=script&lang=js"
import style0 from "./DeptPicker.vue?vue&type=style&index=0&id=51b7132c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b7132c",
  null
  
)

export default component.exports